import firebase from 'firebase';
import { db, storage } from './firebase';
import { firestoreKeys } from '../utils/constants';

// ----------------------------------------------------------------------

export default function useListingsService() {
  const createListing = () =>
    db.collection(firestoreKeys.LISTINGS).add({
      meta: {
        createdDate: firebase.firestore.FieldValue.serverTimestamp(),
        modifiedDate: firebase.firestore.FieldValue.serverTimestamp(),
      },
    });

  const updateListing = (listingId, data) => db.collection(firestoreKeys.LISTINGS).doc(listingId).update(data);

  const uploadListingImage = async (listingId, image) => {
    const filename = `${Date.now()}-${image.name}`;
    const ref = storage.ref(`${firestoreKeys.LISTINGS}/${listingId}/${filename}`);
    await ref.put(image);
    return ref.getDownloadURL();
  };

  const deleteListingImage = async (listingId, imageUrl) => {
    try {
      const imageRef = storage.refFromURL(imageUrl);
      await imageRef.delete();
      return true;
    } catch (error) {
      console.error('Error deleting image:', error);
      return false;
    }
  };

  const deleteListing = (listingId) => db.collection(firestoreKeys.LISTINGS).doc(listingId).delete();

  return { createListing, uploadListingImage, updateListing, deleteListing, deleteListingImage };
}
